/* eslint-disable camelcase */
export default {
	home: 'Home',
	my_dashboard: 'My Dashboard',
	project_planning: 'Project Planning',
	project_planning_desc_1: 'Project planning includes applying for master projects and campaigns.',
	procurement_and_acceptance: 'Procurement and Acceptance',
	procurement_and_acceptance_desc_1:
		'A successful procurement needs to identify the need for marketing services, research potential vendors, issue requests for proposals, evaluate proposals, select a vendor, negotiate a contract, and ultimately acquire the services.',
	procurement_and_acceptance_desc_2:
		'Acceptance of service orders is needed after the order is completed. This involves testing, validating the services, and collecting KPI ratio data to ensure they are fit for purpose and meet the agreed-upon quality standards.',
	project_closing_and_evaluation: 'Project Closing and Evaluation',
	project_closing_and_evaluation_desc_1:
		"When a project is finished, use pre-set KPI ratios to accurately measure a project's outcome. Collecting and analyzing project data and establishing an overseas marketing data warehouse for future project analysis. ",
	new_campaign: 'New Campaign',
	new_campaign_desc_1: 'Create new campaign under master project. An MBA campaign will be automatically created at the same time.',
	purchase_request_and_supplier_selection: 'Purchase Request and Supplier Selection',
	purchase_request_and_supplier_selection_desc_1:
		'Business team submit purchase request in GMS. Procurement team analyze requests and select the most suitable supplier.',
	contract_order: 'Contract / Order',
	contract_order_desc_1: 'Sign contract and placing orders accordingly.',
	service_acceptance: 'Service Acceptance',
	service_acceptance_desc_1:
		'After the order is finished, business team check service deliverables, fill out KPI ratios and conduct service acceptance.',
	payment: 'Payment',
	payment_desc_1: 'Create payments to suppliers after service acceptance.',
	project_closing_evaluation: 'Project Closing & Evaluation',
	project_closing_evaluation_desc_1: 'Collecting and analyzing project KPI ratios.',
	what_to_do_next: 'What to do next?',
	initiate_this_project_based_on_project_initiation_and_suppliers: 'Initiate this project based on project initiation and suppliers',
	create_a_new_project: 'Create a new project',
	need_any_help: 'Need any help?',
	useful_toolkit: 'Useful Toolkit',
	quotation_template: 'Quotation Template',
	same_order_query: 'Same Order Query',
	framework_agreement_query: 'Framework Agreement Query',
	contact: 'Contact',
	contract_person_name: 'IEG：Audreywang(wangkeke)；',
	guidance: 'Guidance',
	bfc_usage_guidelines: 'BFC Usage Guidelines',
	task_summary:
		'You currently have <strong>{taskNum}</strong> related matters, including <strong>{todoNum}</strong> pending tasks, <strong>{completedNum}</strong> completed tasks, and <strong>{projectNum}</strong> related projects.',
	my_pending_tasks: 'My Pending Tasks ',
	my_completed_tasks: 'My Completed Tasks ',
	projects_i_m_monitoring: "Projects I'm Monitoring ",
	project_creation: 'Project Creation',
	project_creation_desc_1: 'Creating a new project',
	requirements: 'Requirements',
	requirements_desc_1: 'Requirements are necessary features for a product, service, or system to meet stakeholder expectations.',
	supplier_evaluation: 'Supplier Evaluation',
	supplier_evaluation_desc_1:
		'Supplier evaluation is the process of measuring and assessing the performance and capabilities of potential or current suppliers.',
	contract_my_dashboard: 'Contract',
	contract_desc_1:
		'A contract is a legally binding agreement between two or more parties that outlines the terms and conditions of their relationship.',
	purchasing_order: 'Purchasing Order',
	purchasing_order_desc_1:
		'A purchase order is a commercial document issued by a buyer to a seller, indicating the type, quantity, and agreed prices for products or services.',
	service_goods_receiving: 'Service/Goods Receiving',
	service_goods_receiving_desc_1:
		'A purchase order is a commercial document issued by a buyer to a seller, indicating the type, quantity, and agreed prices for products or services.',
	payment_my_dashboard: 'Payment',
	payment_my_dashboard_desc_1: 'Payment is the transfer of money, goods, or services in exchange for something else.',
	project_closure: 'Project Closure',
	project_closure_desc_1:
		'Project closure is the final phase of a project, where the project team completes all remaining activities to formally close out the project.',
	real_time_update_at: 'The above information is real-time data and was last updated on {time}.',
	no_decision_required: 'No Decision Required',
	no_order_generated: 'No Order Generated',
	no_order_created: 'No Order Created',
	payment_status: 'Payment Status',
	closing_status: 'Closing Status',
	requirement_resource_type: 'Requirement Resource Type',
	requirement_ticket_amount: 'Requirement Ticket Amount',
	ordered_amount: 'Ordered Amount',
	remaining_orderable_amount: 'Remaining Orderable Amount',
	// accepted_amount: 'Accepted Amount - {currency}',
	// order_number: 'Order Number',
	order_name: 'Order Name',
	current_order_acceptance_status: 'Current Order Acceptance Status',
	acceptance_status: 'Acceptance Status',
	planning_stage: 'Planning Stage',
	execution_stage: 'Execution Stage',
	evaluation_stage: 'Evaluation Stage',
	campaign_name: 'Campaign Name',
	purchase_require: 'Purchase Require',
	related_decision_number: 'Related decision number',
	current_handler: 'Current handler',
	supplier_name: 'Supplier Name',
	total: 'Total',
	order_amount: 'Order Amount',
	acceptance_amount: 'Acceptance Amount',
	agreed_payment_amount: 'Agreed Payment Amount',
	payment_summary: 'Payment Summary',
	project_completion_summary: 'Project Completion Summary',
	used_amount: 'Used Amount',
	available_amount: 'Available Amount',
	project_amount: 'Project Amount',
	approval_status: 'Approval Status',
	created_time: 'Created Time',
	create_purchase_order: 'Create Purchase Order',
	project_completion: 'Project completion',
	create_decision: 'Create Decision',
	create_order: 'Create Order',
	create_acceptance: 'Create Acceptance',
	create_payment: 'Create Payment',
	no_data_available: 'No Data Available',
	// 供应商新增的------------------------------
	enterprise_info: 'Enterprise Info.',
	supplier_nature: 'Supplier Nature',
	certificate_license_number: 'Certificate / License Number',
	supplier_management_system: 'Supplier Management System',
	bid_opening_evaluation_admission: 'Bid opening · evaluation · admission',
	tencent_supplier_portal: 'Tencent Supplier Portal',
	invitation_number: 'Invitation No.',
	invitation_type: 'Invitation Type',
	bg: 'BG',
	supplier_category: 'Supplier Category',
	response_time: 'Response Time',
	enquiry_number: 'Enquiry No.',
	enquiry_name: 'Enquiry Name',
	invitation_acceptance_deadline: 'Invitation Acceptance Deadline',
	// proposal_and_quotation_deadline: 'Proposal And quotation Deadline',
	response_status: 'Response Status',
	operate: 'Operate',
	order_number: 'Order No.',
	contract_number: 'Contract No.',
	buyer: 'Buyer',
	order_date: 'Order Date',
	purchaser: 'Purchaser',
	currency: 'Currency',
	sum: 'Summary',
	accepted_amount: 'Accepted Amount',
	order_type: 'Order Type',
	expected_acceptance_date: 'Estimated Acceptance Date',
	invitations_not_processed: 'Invitation To Be Confirmed',
	enquiries_not_processed: 'Unprocessed Enquiry',
	order_and_acceptance_pending: 'Pending Approval Orders & Acceptances ',
	customer_search: 'Customized Search',
	register_by_supplier: 'Register By Supplier',
	filter: 'Filter',
	exit: 'Exit',
	to_do_list: 'To-do',
	completed: 'Completed',
	register_info: 'Registration Information',
	first: 'First',
	second: 'Second',
	third: 'Third',
	data_types: 'Resource Type',
	no: 'No.',
	invitations_processed: 'Invitation Confirmed',
	enquiries_processed: 'Inquiry Reviewed',
	order_processed: 'Completed Orders',
	acceptance_processed: 'Completed Acceptances',
	proposal_and_quotation_submission: 'Proposal Quotation Submission Date',
	proposal_and_quotation_deadline: 'Proposal Quotation Deadline',
	order_status: 'Order Status',
	acceptance_completion_date: 'Acceptance completion date',
	expected_payment_date: 'Estimated Payment Date',
	payment_info: 'Payment Info',
	acceptance_certificate_number: 'Acceptance No.',
	status: 'Status',
	system: 'System',
	announcement: 'Announcement',
	more: 'More',
	initiate_acceptance: 'Create Acceptance',
	detail: 'detail',
	system_announcement: 'System Announcement',
	// invitation_number: 'Invitation Number',
	name: 'Invitation Transactor',
	telephone: 'Contact Phone',
	address: 'Contact Address',
	vendor_category: 'Supplier Category',
	invitation_date: 'Invitation Creation Time',
	static: 'static',
	dynamic: 'dynamic',
	please_enter_the_tracking_number: 'Please enter the tracking number!',
	please_enter_buyer_or_purchaser: 'Please enter buyer or purchaser!',
	po_pending_acceptance: 'PO Pending Acceptance',
	error_home_page_tip_1: 'Supplier binding not found. ',
	error_home_page_tip_2: 'Please check if the appropriate role has been selected or contact the 87000 Finance IT hotline for assistance.',
	bind_supplier: 'Binding Supplier',
	payment_no: 'Payment No.',
	currency_name: 'Currency',
	amount: 'Amount',
	fin_status_name: 'Status',
	new_user_application: 'New user application',
	administrator_application: 'Administrator application'
};
